import { Component, inject, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { LegalPagesService } from '../../services/legal-pages.service';

@Component({
  selector: 'app-privacy-settings',
  standalone: false,
  templateUrl: './privacy-settings.component.html',
  styleUrl: './privacy-settings.component.scss',
})
export class PrivacySettingsComponent implements OnDestroy {
  private legalPagesService = inject(LegalPagesService);

  privacySettings = '';

  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.legalPagesService
      .getLegalHtmlPage('privacy-settings')
      .pipe(takeUntil(this.destroy$))
      .subscribe((text) => (this.privacySettings = text));
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
